import {gemStore} from 'app/gemStore';

import {MOBILE_HEADER_SLICE_KEY, MobileHeaderStoreState} from './types';

export const openMobileMenuAction = () => {
    updateMobileHeaderState('mobileHeader/openMobileMenuAction', (state) => ({...state, mobileMenu: true}));
};

export const closeMobileMenuAction = () => {
    updateMobileHeaderState('mobileHeader/closeMobileMenuAction', (state) => ({...state, mobileMenu: false}));
};

export const setMobileHeaderStateAction = (state: number) => {
    updateMobileHeaderState('mobileHeader/setMobileHeaderStateAction', (mobileHeaderState) => ({...mobileHeaderState, mobileHeaderState: state}));
};

export const bypassMobileHeaderScrollEventAction = (bypass: boolean) => {
    updateMobileHeaderState('mobileHeader/bypassMobileHeaderScrollEventAction', (state) => ({...state, bypassScrollEvent: bypass}));
};

function updateMobileHeaderState(actionName: string, updateFn: (state: MobileHeaderStoreState) => MobileHeaderStoreState) {
    const state = gemStore.getState()[MOBILE_HEADER_SLICE_KEY];

    if (!state) {
        return;
    }

    gemStore.setState({[MOBILE_HEADER_SLICE_KEY]: updateFn(state)} as never, false, actionName);
}
